/* eslint-disable no-underscore-dangle */

import { APP_ROUTES } from '@constants/routes';

export function getCategoriesPerLevel(tree) {
  const categories = {
    firstLevel: [],
    secondLevel: [],
    thirdLevel: []
  };

  if (tree?.length > 0) {
    tree.forEach((firstCategory) => {
      categories.firstLevel.push({ ...firstCategory, path: `${APP_ROUTES.CATEGORIES}` });
      if (firstCategory.children?.length > 0) {
        categories.secondLevel.push({
          title: firstCategory.name,
          slug: firstCategory.slug,
          children: firstCategory.children,
          path: `${APP_ROUTES.CATEGORIES}/${firstCategory.slug}`
        });
        firstCategory.children?.forEach((secondCategory) => {
          if (secondCategory.children?.length > 0) {
            categories.thirdLevel.push({
              title: secondCategory.name,
              slug: `${secondCategory.slug}`,
              children: secondCategory.children,
              path: `${APP_ROUTES.CATEGORIES}/${firstCategory.slug}/${secondCategory.slug}`
            });
          }
        });
      }
    });

  }

  return categories;
}

export function findCategoryBySlug(list, slug) {
  try {
    const trail = [];
    let found = null;
    const recurse = (categories) => {
      for (let i = 0; i < categories.length; ++i) {
        trail.push({
          code: categories[i].code,
          name: categories[i].name,
          slug: categories[i].slug,
          children: categories[i].children || []
        });

        if (categories[i].slug === slug) {
          found = categories[i];
          break;
        } else if (categories[i].children) {
          recurse(categories[i].children);
          if (found) {
            break;
          }
        }
        trail.pop();
      }
    };
    recurse(list);
    return {
      category: found,
      trail
    };
  } catch (err) {
    return {
      category: null,
      trail: null
    };
  }
}

export function getBreadcrumbsFromTrail(trail, options = {}) {
  const { shouldIncludeHome = true, omitLast = false } = options;
  const items = [];
  let path = APP_ROUTES.CATEGORIES;

  if (shouldIncludeHome) {
    items.push({
      href: APP_ROUTES.HOME,
      name: 'NAVIGATION.HOME',
      translate: true
    });
  }

  trail?.forEach((item) => {
    const { slug, name } = item;
    path += `/${slug}`;
    items.push({
      href: path,
      name
    });
  });

  if (omitLast) {
    items.pop();
  }

  return items;
}

export function buildHrefFromTrail(trail = []) {
  return trail?.reduce((href, category) => href += `/${category.slug}`, APP_ROUTES.CATEGORIES);
}

// Navigation

export function getCategoriesNavigationMap(categories, params) {
  return categories.reduce((acc, c) => {
    return categoriesMapReducer(acc, c, c, params);
  }, {
    __parents: {}
  });
}

// --- Helpers

const categoriesMapReducer = (acc, parent, child, params) => {
  const { slug: parentSlug } = parent;
  const { slug: childSlug, children: subChildren } = child;

  if (!acc.__parents[parentSlug]) {
    acc.__parents[parentSlug] = getCategoryNavigationItem(parent, params);
  }

  acc[childSlug] = acc.__parents[parentSlug];

  if (subChildren) {
    subChildren.map((c) => categoriesMapReducer(acc, parent, c));
  }

  return acc;
};

const getCategoryNavigationItem = (category, params) => {
  const { slug, children } = category || {};
  return {
    parent: parseCategoryNavigationItem({
      item: category,
      baseHref: APP_ROUTES.CATEGORIES,
      matchBaseHref: APP_ROUTES.CATEGORIES_FILTERED,
      withImage: true,
      withChildren: false,
      params,
    }),
    children: children?.map((c) => parseCategoryNavigationItem({
      item: c,
      baseHref: `${APP_ROUTES.CATEGORIES}/${slug}`,
      matchBaseHref: `${APP_ROUTES.CATEGORIES_FILTERED}/${slug}`,
      withImage: false,
      withChildren: true,
      params
    }))
  };
};

const parseCategoryNavigationItem = ({
  item,
  baseHref,
  matchBaseHref,
  withImage,
  withChildren,
  params
}) => {
  const { t } = params || {};

  const {
    slug,
    name: label,
    iconPng,
    exact,
    children,
  } = item || {};

  const pathname = `${baseHref}/${slug}`;
  const matchPathname = `${matchBaseHref}/${slug}`;

  const href = withChildren ? null : pathname;
  const as = withChildren ? null : pathname;
  const matchHref = withChildren ? null : matchPathname;

  return {
    id: slug,
    slug,
    label,
    href,
    as,
    matchHref,
    exact,
    image: withImage ? iconPng : null,
    children: (!withChildren || !children?.length)
      ? []
      : [
        parseCategoryNavigationItem({
          item: {
            slug,
            name: t('CATEGORIES.ALL'),
            exact: true,
          },
          baseHref: `${baseHref}`,
          matchBaseHref: `${matchBaseHref}`,
          withImage: false,
          withChildren: false,
          params
        }),
        ...children.map((childItem) => {
          return parseCategoryNavigationItem({
            item: childItem,
            baseHref: `${baseHref}/${slug}`,
            matchBaseHref: `${matchBaseHref}/${slug}`,
            withImage: false,
            withChildren: false,
            params
          });
        })
      ]
  };
};
